import { assign, createMachine, Interpreter } from 'xstate-v4'
import { PromoPages } from './schemas'

interface Event {
  type: 'FETCH'
  slug: string
}

interface Context {
  data?: PromoPages
}

export function returnPromoPagesMachine() {
  return createMachine<Context, Event>(
    {
      context: {},
      initial: 'idle',
      states: {
        idle: {
          on: {
            FETCH: 'fetching',
          },
        },
        fetching: {
          invoke: {
            src: 'fetch',
            onDone: {
              target: 'results',
              actions: assign({
                // TODO: Add proper type for XState event data
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                data: (_, { data }) => data,
              }),
            },
            onError: {
              actions: 'logError',
              target: 'error',
            },
          },
        },
        results: { type: 'final' },
        error: { type: 'final' },
      },
    },
    {
      actions: {
        logError: (_, _event: any) => {
          throw new Error('promoPagesMachine logError not implemented')
        },
      },
      services: {
        fetch: () => {
          throw new Error('promoPagesMachine fetch not implemented')
        },
      },
    },
  )
}

export type PromoPagesMachineInterpreter = Interpreter<Context, object, Event>
